import { useState } from 'react'

import { Box, Container } from '@material-ui/core'
import { PageTitle } from '@scoir/headers'

import useTitle from 'common/use-title'
import CopyCurrentRoundsAlert from 'routes/application/AppCycleRounds/CopyCurrentRoundsAlert.tsx'
import CurrentUpcomingAppCycleToggle from 'routes/application/CurrentUpcomingAppCycleToggle.tsx'
import { useAppCycle, useRoundConfigurationAppCycle } from 'store/application-cycle/hooks'
import { useConfigureUpcomingApplicationCycle } from 'store/feature-toggle/hooks'

import AppManagerRoleBanner from '../Configure/components/RoleBanner'
import { useCanViewReadOnly } from '../useCanConfigureApplications'
import AppRoundMessaging from './AppRoundMessaging'
import AppRoundProvider from './AppRoundProvider'
import AppRoundSection from './AppRoundSection'
import RequirementSection from './RequirementSection'
import RoundRequirementsProvider from './RoundRequirementsProvider'

const AppCycleRounds = () => {
  useTitle('Scoir - Set Rounds')

  const isConfigureUpcomingEnabled = useConfigureUpcomingApplicationCycle()
  const currentAppCycle = useAppCycle()
  const upcomingCycle = useRoundConfigurationAppCycle()
  const defaultCycle = isConfigureUpcomingEnabled ? upcomingCycle : currentAppCycle
  const [applicationCycle, setApplicationCycle] = useState<number>(defaultCycle)
  const [isCurrent, setHasCurrentFocus] = useState(isConfigureUpcomingEnabled ? false : true)
  const readOnlyView = useCanViewReadOnly()

  return (
    <RoundRequirementsProvider applicationCycle={applicationCycle}>
      <AppRoundProvider applicationCycle={applicationCycle}>
        <Box my={4}>
          <Container maxWidth="lg">
            <AppManagerRoleBanner />
            <PageTitle
              title="Set Rounds"
              actions={
                isConfigureUpcomingEnabled && (
                  <CurrentUpcomingAppCycleToggle
                    hasCurrentFocus={isCurrent}
                    onChangeCycleFocus={(isFocused) => {
                      setHasCurrentFocus(isFocused)
                      setApplicationCycle(isFocused ? currentAppCycle : upcomingCycle)
                    }}
                  />
                )
              }
            />
            <Box mb={2}>
              <CopyCurrentRoundsAlert />
            </Box>
            {!readOnlyView && <AppRoundMessaging isCurrent={isCurrent} />}
            <Box mb={2}>
              <RequirementSection />
            </Box>
            <Box my={2}>
              <AppRoundSection />
            </Box>
          </Container>
        </Box>
      </AppRoundProvider>
    </RoundRequirementsProvider>
  )
}

export default AppCycleRounds
